import $ from 'jquery'

const miFooter = () => {
    // Bind to the outer container to survive DOM replacements from footer-grid.js
    const $footerContainer = $('.mi-footer--menu');

    // Make all menus open on first render
    $footerContainer.find('.menu-item-has-children').addClass('is-active');

    // Disable SmartMenus completely on the footer to eliminate hover glitches
    setTimeout(() => {
        // Query the elements again inside the timeout in case footer-grid.js has replaced them
        const $footerMenu = $footerContainer.find('.elementor-nav-menu');

        if ($.fn.smartmenus) {
            $footerMenu.smartmenus('destroy');
        }

        // Remove inline styles if any were set previously
        $footerMenu.find('ul.sub-menu').removeAttr('style');
    }, 100);

    // Accordion click logic (pure CSS driven)
    // Delegate the event to the static container rather than the dynamic <ul>
    $footerContainer.on('click', '.menu-item-has-children > a', function (e) {
        const $target = $(e.target);
        const $parentLi = $(this).parent();
        const href = $(this).attr('href');
        const isDummyLink = !href || href === '#' || href.trim() === '' || href.startsWith('javascript:');

        // If the arrow button (.sub-arrow) is clicked, toggle expand/collapse
        if ($target.closest('.sub-arrow').length) {
            e.preventDefault();
            e.stopPropagation();
            $parentLi.toggleClass('is-active');
            return;
        }

        // If the link has no valid URL (e.g. '#'), toggle expand/collapse
        if (isDummyLink) {
            e.preventDefault();
            $parentLi.toggleClass('is-active');
        }
        // Valid page URLs navigate to the target page normally
    });
}

try {
    miFooter();
} catch (error) {
    console.warn(error);
}